module.exports = "<p>\n  loginviatranscend works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/loginviatranscend/loginviatranscend.component.html
// module id = 665
// module chunks = 1